// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RI-cb","largestCol":"styles_largestCol__lZWsc","smallestCol":"styles_smallestCol__1bxkg"};